// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__JAc4e","productName":"Table_productName__1i-v9"};